import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import { reactive, toRefs, onMounted } from 'vue';
import apis from "@/api";
export default {
  components: {},
  props: {
    demandId: {
      type: String
    }
  },
  setup(props, context) {
    const data = reactive({
      activeTab: 'proc',
      processLogs: [],
      demandLogs: [],
      partnerLogs: []
    });
    const processLog = () => {
      apis.processLog({
        demandId: props.demandId
      }).then(res => {
        if (res.success) {
          data.processLogs = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const demandLog = () => {
      apis.demandLog({
        demandId: props.demandId
      }).then(res => {
        if (res.success) {
          data.demandLogs = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const partners = () => {
      apis.partners({
        demandId: props.demandId
      }).then(res => {
        if (res.success) {
          data.partnerLogs = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const refresh = () => {
      processLog();
      demandLog();
      partners();
    };
    return {
      ...toRefs(data),
      refresh
    };
  }
};